import { render, staticRenderFns } from "./reduceCostHistoryShenpi.vue?vue&type=template&id=2fa5d596"
import script from "./reduceCostHistoryShenpi.vue?vue&type=script&lang=js"
export * from "./reduceCostHistoryShenpi.vue?vue&type=script&lang=js"
import style0 from "./reduceCostHistoryShenpi.vue?vue&type=style&index=0&id=2fa5d596&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports